module.exports = __webpack_public_path__ + "media/images/bg/mosaic/pattern-arrows-red-0cb5f551c2f7d49fb39218c8fee581fe.svg";